/**
 * Utility para limpar dados obsoletos de autenticação do localStorage/sessionStorage
 * Deve ser executado uma vez na inicialização do app para remover dados antigos
 */
export const cleanupOldAuthData = () => {
  const keysToRemove = [
    'user',
    'userProfile',
    'userRights',
    'rightsByModule',
    'authToken',
    'refreshToken',
    'permissions',
    'menuData',
  ];

  console.log('🧹 Limpando dados de autenticação obsoletos...');

  let removedCount = 0;

  keysToRemove.forEach(key => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
      removedCount++;
      console.log(`  ❌ Removido do localStorage: ${key}`);
    }
    if (sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key);
      removedCount++;
      console.log(`  ❌ Removido do sessionStorage: ${key}`);
    }
  });

  if (removedCount > 0) {
    console.log(`✅ Limpeza concluída: ${removedCount} chaves removidas`);
  } else {
    console.log('✅ Nenhum dado obsoleto encontrado');
  }
};
